'use client'

import { Step } from '@/features/flyer/configs/steps'
import { useFlyerBuilderState } from '@/features/flyer/store/FlyerBuilderStateProvider'
import { AgentDetailsStep, DestinationStep, FlyerStep, ItineraryStep, NotesStep, SelectPriceListStep } from '../uiComponents'
import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'
import { useSitecoreState } from '@/features/sitecore/store/useSitecoreState'

type StepsComponent = { [key in Step]: JSX.Element }

export const FlyerBuilderActions = () => {
	const { getActiveStep, flyerType } = useFlyerBuilderState((state) => state)
	const sitecoreStore = useSitecoreState((state) => state)

	const stepComponentsTactical: Partial<StepsComponent> = {
		destination: <DestinationStep />,
		itinerary: <ItineraryStep />,
		priceList: <SelectPriceListStep />,
		agentDetails: <AgentDetailsStep />,
		notes: <NotesStep />,
		flyer: <FlyerStep />,
	}

	const stepComponentsProduct: Partial<StepsComponent> = {
		agentDetails: <AgentDetailsStep />,
		flyer: <FlyerStep />,
	}

	const stepComponents = flyerType !== 'tactical' ? stepComponentsProduct : stepComponentsTactical
	//CHECK IF SOME STEPS NEEDS TO BE SKIPPED
	const filteredStepComponents = Object.keys(stepComponents).reduce((acc, key) => {
		const stepKey = key as keyof StepsComponent
		if (!sitecoreStore.getBoolean(TranslationBundles.BUILD_YOUR_FLYER, `MSC-BUILD_YOUR_FLYER-SKIP-STEP-${stepKey.toUpperCase()}`, false)) {
			acc[stepKey] = stepComponents[stepKey]
		}
		return acc
	}, {} as Partial<StepsComponent>)

	return <div className="h-full py-8 px-6 shadow-md overflow-y-scroll pb-28">{filteredStepComponents[getActiveStep()]}</div>
}
